<div class="container-fluid" tabindex="0">
    <section id="resultat">
      
      <div class="row">
        <div class="col-sm-12 form-group">

          <div class="row" *ngIf="possedeDesDroits">
            <div class="col-sm-12">
              <div class="row mise-en-avant-fond-cnaf" style="margin: 5px">
                <div class="col-sm-6 col-md-6" style="display: inline-flex; margin-top:10px; margin-bottom:10px">
                  <div style="margin: auto;">
                    <img src="/icfstatiquesangularappli/dist/images/usager/PicTP-resultat.png"
                      alt="pictogramme calculette" />
                  </div>
                  <div>
                    <p style="margin: 20px;">
                      Selon les informations fournies, vous pouvez recevoir :
                    </p>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6" style="padding:10px; vertical-align: middle;">
                  <div>
                    <p class="text-primary"
                      style="font-size: 16pt;background-color: rgb(255,255,255); padding: 10px; margin:15px; text-align: center">
                      <strong>{{ montantDroit }} € par mois</strong>.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="row" *ngIf="!possedeDesDroits">
            <div class="col-sm-12">
              <div class="row" style="margin-top: 20px">
                <div class="col-sm-12" style="display: inline-flex;">
                  <div style="margin-left: 15px">
                    <img src="/icfstatiquesangularappli/dist/images/usager/PicTP-resultat.png"
                      alt="pictogramme calculette" />
                  </div>
                  <div>
                    <p style="margin-left: 20px">
                      <strong>Selon les informations fournies, vous ne pouvez pas bénéficier de l'aide au logement.
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="margin-top: 15px;" class="col-sm-12"
            *ngIf="nombreEnfantMoinsXXansAvecRevenusSuperieur>0 && possedeDesDroits">
            <p class="texte-clair-cnaf">
              Vous avez indiqué avoir {{nombreEnfantMoinsXXansAvecRevenusSuperieur}} enfant(s) de moins de {{seuilAge}}
              ans avec un revenu supérieur à 4500 €, il est possible que cette estimation soit majorée.
            </p>
          </div>
          <div style="margin-top: 15px;">
            <div class="col-sm-12">
              Cette estimation est fournie à titre indicatif. Seule la demande d'aide au logement vous garantit un montant
              exact.
            </div>
          </div>
          <div style="margin-top: 15px;"
            *ngIf="estAccession && possedeDesDroits">
            <div class="col-sm-12">
              Compte tenu des informations que vous nous avez fournies, nous vous invitons à contacter votre Caf pour poursuivre votre demande.
            </div>
          </div>
          <div class="row row-btn-cnaf"></div>

          <div class="row row-btn-cnaf">
            <div class="col-sm-12 form-group">
              <span class="float-start">
                <app-bouton-quitter [pageName]="pageName"></app-bouton-quitter>
              </span>
              <div *ngIf='possedeDesDroits && !estAccession'>
                <span class="float-end">
                  <button (click)="clickSuivant()" id="btn-faire-demande" type="submit" value="Faire la demande"
                    title="Faire la demande" class="btn btn-form-cnaf btn-majeur-cnaf btn-mobile">
                    Faire la demande
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
